import { Capacitor } from '@capacitor/core';
import _oyakLogoPng from '../../assets/images/logo/logo-variant4.png';
import _oyakLogoSvg from '../../assets/images/logo/logo-variant4.svg';

export enum EnvironemtTypes {
  PROD = 'prod',
  DEV = 'dev',
}

class _EnvironmentVariables {
  private static _instance: _EnvironmentVariables;

  private constructor() {
    this._EnvironmentType = process.env.ENV || '';
    this._Api_Default_Base_Url = process.env.DEFAULT_BASE_URL || '';
    this._WMS_URL = process.env.WMS_URL || '';
    this._RAPOR_DOWNLOAD_URL = process.env.RAPOR_DOWNLOAD_URL || '';
    this._RAPOR_SHOW_URL = process.env.RAPOR_SHOW_URL || '';
    this._Api_Default_Service_Url = process.env.DEFAULT_SERVICE_URL || '';
    this._Api_Has_Proxy = process.env.HAS_PROXY === 'true';
    this._Is_Mobile = Capacitor?.isNative || false;
    this._Platform = (Capacitor?.getPlatform() || 'web') as 'web' | 'android' | 'ios';
    this._Storage_Access_Key = process.env.STORAGE_ACCESS_KEY || '';
    this._Build_Name = process.env.ENV_BUILD_NAME || '0.1';
    this._Build_Code = Number(process.env.ENV_BUILD_CODE) || 1;
    this._OyakLogoPng = _oyakLogoPng;
    this._OyakLogoSvg = _oyakLogoSvg;
  }

  public static Instance() {
    return this._instance || (this._instance = new this());
  }

  private _EnvironmentType: string;
  public get EnvironmentType(): string {
    return this._EnvironmentType;
  }

  private _Api_Default_Base_Url: string;
  public get Api_Default_Base_Url(): string {
    return this._Api_Default_Base_Url;
  }

  private _Api_Default_Service_Url: string;
  public get Api_Default_Service_Url(): string {
    return this._Api_Default_Service_Url;
  }

  private _Api_Has_Proxy: boolean;
  public get Api_Has_Proxy(): boolean {
    return this._Api_Has_Proxy;
  }

  private _Is_Mobile: boolean;
  public get Is_Mobile(): boolean {
    return this._Is_Mobile;
  }

  private _Platform: 'web' | 'android' | 'ios';
  public get Platform(): 'web' | 'android' | 'ios' {
    return this._Platform;
  }

  private _WMS_URL: string;
  public get WMS_URL(): string {
    return this._WMS_URL;
  }

  private _RAPOR_DOWNLOAD_URL: string;
  public get RAPOR_DOWNLOAD_URL(): string {
    return this._RAPOR_DOWNLOAD_URL;
  }

  private _RAPOR_SHOW_URL: string;
  public get RAPOR_SHOW_URL(): string {
    return this._RAPOR_SHOW_URL;
  }

  private _Storage_Access_Key: string;
  public get Storage_Access_Key(): string {
    return this._Storage_Access_Key;
  }

  private _Build_Name: string;
  public get Build_Name(): string {
    return this._Build_Name;
  }

  private _Build_Code: number;
  public get Build_Code(): number {
    return this._Build_Code;
  }

  private _OyakLogoPng: any;
  public get OyakLogoPng(): any {
    return this._OyakLogoPng;
  }

  private _OyakLogoSvg: any;
  public get OyakLogoSvg(): any {
    return this._OyakLogoSvg;
  }
}

export const EnvironmentVariables = _EnvironmentVariables.Instance();
